<template>
  <div class="width-100-pr">
    <input
      v-model="diaNodo"
      class="a-input-side a-input-primary text-align-center width-25-px"
      :min="minDia"
      name="dia"
      type="number"
      @keyup="changeDay"
    />
    <span class="node-activation-date">
      {{ activationDate }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingContentsTreeNodeInmediate',

  props: {
    contenido: Object,
    element: Object,

    info: {
      type: Object,
      default: null
    },

    nodo: Object,

    parent: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      diaNodo: ''
    }
  },

  computed: {
    activationDate () {
      if (this.diaNodo === '') {
        return this.$t('mEditionAssetContentsTreeNode.messages.notActivated')
      } else if (this.diaNodo === 0) {
        return this.element.fecha_inicio
          ? this.$moment.parseZone(this.element.fecha_inicio).format('YYYY-MM-DD')
          : this.$t('mEditionAssetContentsTreeNode.messages.inmediate')
      } else {
        return this.element.fecha_inicio
          ? this.$moment.parseZone(this.element.fecha_inicio).add(parseInt(this.diaNodo), 'days').format('YYYY-MM-DD')
          : this.$t('mEditionAssetContentsTreeNode.messages.daysAfter')
      }
    },

    minDia () {
      return this.parent !== null ? this.searchDay(this.parent.id) : -1
    }
  },

  watch: {
    'info.nodosActivos': {
      deep: true,

      handler () {
        let dia = this.searchDay(this.nodo.id)
        this.diaNodo = dia === -1 ? '' : dia
      }
    },

    minDia () {
      if (this.minDia > 0 && this.minDia > this.diaNodo) {
        this.diaNodo = this.minDia
        this.$emit('emitAction', { nodo: this.nodo.id, dia: this.minDia })
      }
    }
  },

  created () {
    let dia = this.searchDay(this.nodo.id)
    this.diaNodo = dia === -1 ? '' : dia
  },

  methods: {
    changeDay (event) {
      this.$emit('emitAction', { nodo: this.nodo.id, dia: event.target.value })
    },

    searchDay (idNodo) {
      return parseInt(this.info.nodosActivos.nodos.find(anodo => anodo.nodo === idNodo).dia)
    }
  }
}
</script>
